import { NotificationDetailMobilePage } from '@/pages/mobile/shared/NotificationDetailMobilePage';

export function EmployeeNotificationDetailMobilePage() {
  return <NotificationDetailMobilePage variant="employee" />;
}
